import { useEffect, useRef, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { hoyMadrid } from '@/lib/llamadas/fechas';
import { kpisDia } from '@/lib/llamadas/presentacion';
import { useLlamadas } from '@/hooks/useLlamadas';
import { DetalleLlamada } from './DetalleLlamada';
import { FeedLlamadas } from './FeedLlamadas';
import { KpisDia } from './KpisDia';
import { Icono } from '../Layout/iconos';

// Pantalla Atención (prototipo iter5): KPIs del día + grid feed/detalle.

export function AtencionPage() {
  // Deep-link desde el cuadro de mando (spec cuadro-mando §4): ?dia como día
  // inicial (si es válido) y ?call como selección preferente. Lectura única al
  // montar; las interacciones posteriores no reescriben la URL.
  const [searchParams] = useSearchParams();
  const [dia, setDia] = useState(() => {
    const d = searchParams.get('dia');
    // round-trip: '2026-13-99' pasa la regex pero no es una fecha (AR-003)
    if (d && /^\d{4}-\d{2}-\d{2}$/.test(d)) {
      const [y, m, dd] = d.split('-').map(Number);
      const fecha = new Date(Date.UTC(y ?? 0, (m ?? 1) - 1, dd ?? 1));
      if (fecha.toISOString().slice(0, 10) === d) return d;
    }
    return hoyMadrid();
  });
  const callPendiente = useRef(searchParams.get('call'));
  const { llamadas, cargando, error, recargar } = useLlamadas(dia);
  const [seleccionadaId, setSeleccionadaId] = useState<string | null>(null);

  const seleccionada = llamadas.find((l) => l.id === seleccionadaId) ?? null;

  // como el prototipo: al cargar el día, la primera llamada queda seleccionada
  // (salvo deep-link con una llamada existente, que tiene preferencia)
  useEffect(() => {
    if (llamadas.length === 0) return;
    if (callPendiente.current) {
      const objetivo = llamadas.find((l) => l.id === callPendiente.current);
      callPendiente.current = null;
      if (objetivo) {
        setSeleccionadaId(objetivo.id);
        return;
      }
    }
    if (!seleccionada) {
      setSeleccionadaId(llamadas[0]?.id ?? null);
    }
  }, [llamadas, seleccionada]);

  return (
    <>
      <KpisDia kpis={kpisDia(llamadas)} />
      <section className="grid min-h-0 grid-cols-1 gap-[14px] lg:grid-cols-[minmax(340px,2fr)_3fr]">
        <FeedLlamadas
          llamadas={llamadas}
          dia={dia}
          onCambiarDia={(d) => {
            setDia(d);
            setSeleccionadaId(null);
          }}
          seleccionadaId={seleccionadaId}
          onSeleccionar={setSeleccionadaId}
          cargando={cargando}
          error={error}
          onReintentar={recargar}
        />

        <div className="flex min-h-[300px] flex-col rounded-[var(--radius)] border border-[var(--border)] bg-[var(--surface)] shadow-[var(--shadow-soft)]">
          {seleccionada ? (
            <DetalleLlamada llamada={seleccionada} />
          ) : (
            <div className="m-auto p-8 text-center">
              <Icono nombre="doc" className="mx-auto h-6 w-6 text-[var(--text-mute)]" />
              <p className="mt-3 text-[12.5px] text-[var(--text-dim)]">
                Selecciona una llamada para ver su conversación.
              </p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
